// 生成缩略图
export function resizeImage (src, callback, w, h) {
  var canvas = document.createElement('canvas')
  var ctx = canvas.getContext('2d')
  var im = new Image()
  w = w || 0
  h = h || 0
  im.onload = function () {
    // 为传入缩放尺寸用原尺寸
    !w && (w = this.width)
    !h && (h = this.height)
    // 以长宽最大值作为最终生成图片的依据
    if (w !== this.width || h !== this.height) {
      var ratio
      if (w > h) {
        ratio = this.width / w
        h = this.height / ratio
      } else if (w === h) {
        if (this.width > this.height) {
          ratio = this.width / w
          h = this.height / ratio
        } else {
          ratio = this.height / h
          w = this.width / ratio
        }
      } else {
        ratio = this.height / h
        w = this.width / ratio
      }
    }
    // 以传入的长宽作为最终生成图片的尺寸
    let offset
    if (w > h) {
      offset = (w - h) / 2
      canvas.width = canvas.height = w
      ctx.drawImage(im, 0, offset, w, h)
    } else if (w < h) {
      offset = (h - w) / 2
      canvas.width = canvas.height = h
      ctx.drawImage(im, offset, 0, w, h)
    } else {
      canvas.width = canvas.height = h
      ctx.drawImage(im, 0, 0, w, h)
    }
    callback(canvas.toDataURL('image/png'))
  }
  im.src = src
}

// base64转blob
export function base64ToBlob (base64Data) {
  let arr = base64Data.split(',')
  let fileType = arr[0].match(/:(.*?);/)[1]
  let bstr = atob(arr[1])
  let l = bstr.length
  let u8Arr = new Uint8Array(l)

  while (l--) {
    u8Arr[l] = bstr.charCodeAt(l)
  }
  return new Blob([u8Arr], {
    type: fileType
  })
};

// blob转file
export function blobToFile (newBlob, fileName) {
  newBlob.lastModifiedDate = new Date()
  newBlob.name = fileName
  return newBlob
};

export function urlToBlob (url, callback) {
  let xhr = new XMLHttpRequest()
  xhr.open('get', url + '?time=' + new Date().valueOf(), true)
  xhr.responseType = 'blob'
  xhr.onload = function () {
    if (this.status === 200) {
      if (callback) {
        callback(this.response)
      }
    }
  }
  xhr.send()
};
/* 获取数组中与目标数值最接近的数值 */
export function findCloseNum (arr, num) {
  var index = 0 // 保存最接近数值在数组中的索引
  var d_value = Number.MAX_VALUE // 保存差值绝对值，默认为最大数值
  for (var i = 0; i < arr.length; i++) {
    var new_d_value = Math.abs(arr[i] - num) // 新差值
    if (new_d_value <= d_value) { // 如果新差值绝对值小于等于旧差值绝对值，保存新差值绝对值和索引
      if (new_d_value === d_value && arr[i] < arr[index]) { // 如果数组中两个数值跟目标数值差值一样，取大
        continue
      }
      index = i
      d_value = new_d_value
    }
  }
  return arr[index] // 返回最接近的数值
}
